// eslint-disable-next-line max-len
export const INVALID_PROJECT_TEXT_MESSAGE = 'Invalid Text: Only a-z, 0-9, ! @ # $ % ^ & * ( ) - _ + , . ? " \' : ; \\ are allowed.';
export const INVALID_NAME_LENGTH_MESSAGE = 'Project Names can be at most 80 characters';

// eslint-disable-next-line max-len
export const INVALID_PROJECT_NUMBER_MESSAGE = 'Invalid Text: Only a-z, 0-9 are allowed.';
export const INVALID_PROJECT_LENGTH_MESSAGE = 'Project Numbers must be exactly 10 characters';